import { Classroom } from "./classrooms.model";
import { Course } from "./courses.model";

class ActivityModel {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public materials: Material[],
    public scoreRange: number,
    public courseId: string,
    public chapterId: string,
    public classroomId: string,
    public startDate: Date | null = null,
    public finalDate: Date | null = null,
    public deleted: boolean | null = null
  ) {}
}
class FormActivity {
  constructor(
    public courseId: string| undefined = undefined,
    public classroomId: string | undefined = undefined,
    public title: string = "",
    public startDate: Date | null | string = null,
    public finalDate: Date | null | string = null,
    public finalHour: string = "",
    public description: string = "",
    public learningObjetiveId: string = "",
    public scoreRange: number | null = null,
    public chapterId: string = "",
    public files: File[] | null = null,
    public materialsToRemove: string[] | null = null,
    public materials: Material[] = [],
    public classroom?: Classroom,
    public course?: Course
  ) {}
}

class Material {
  constructor(
    public id: string,
    public path: string,
    public url: string,
    public name: string,
    public mimetype: string,
    public duration: number | null = null,
    public status: string,
    public secure: boolean,
    public transcriptId: string | null = null,
    public learningObjectId: string | null = null,
    public courseName: string | null = null,
    public chapterName: string | null = null,
    public learningObjectName: string | null = null
  ) {}
}
class Media {
  constructor(
    public id: string,
    public chapterName: string,
    public courseName: string,
    public duration: number,
    public learningObjectId: string,
    public learningObjectName: string,
    public mimetype: string,
    public name: string,
    public path: string,
    public referenceTranscriptId: string,
    public secure: boolean,
    public status: StatusMedia,
    public transcriptId: string,
    public url: string
  ) {}
}

class FormCorrection {
  constructor(public score: number = 0, public feedback: string = "") {}
}
enum Status {
  CLOSED = "CLOSED",
  FEEDBACK = "FEEDBACK",
  OPEN = "OPEN",
}
enum StatusMedia {
  DONE = "DONE",
  FAIL = "FAIL",
  WAITING = "WAITING",
}
class StudentActivity {
  constructor(
    public activity: ActivityModel,
    public conclusionDate: Date | null = null,
    public feedback: string | null = null,
    public score: number = 0,
    public startDate: Date,
    public status: Status,
    public student: any,
    public textAnswer: string,
    public mediaAnswer: Media
  ) {}
}
class StudentActivityInfo {
  constructor(
    // public studentActivityId?: string,
    public activityId?: string,
    public title?: string,
    public started?: boolean,
    public status?: ActivityStatus,
    public finalDate?: Date,
    public score?: number,
    public scoreRange?: number
  ) {}
}
enum ActivityStatus {
  ASSIGNED = "ASSIGNED",
  OVERDUE = "OVERDUE",
  FEEDBACK = "FEEDBACK",
  NOT_STARTED = "NOT_STARTED",
}
class StudentActivityTableInfo {
  constructor(
    public studentActivityId?: string,
    public activityId?: string,
    public title?: string,
    public info?: string,
    public status?: styledStatus
  ) {}
}
enum ActivityResult {
  APPROVED = "APPROVED",
  REPROVED = "REPROVED",
}

interface styledStatus {
  class: string;
  value: string;
  text: string;
  icon: string;
  tooltip: string;
}
export {
  ActivityModel,
  FormActivity,
  FormCorrection,
  StudentActivity,
  StudentActivityTableInfo,
  StudentActivityInfo,
  Status,
  ActivityStatus
};
